import React, { Component } from 'react';
import { StyleSheet, View, Text, TouchableOpacity, Linking } from 'react-native';
import { Table } from '../../components/Table';
import { Row, Rows } from '../../components/Rows';

class Content1 extends Component {
    render() {
        return (
            <View>
                <Text style={styles.heading}>
                    {
                        "Appendix 2 - Outstanding AR/AP "
                    }
                </Text>
                <Text style={styles.subheading}>
                    {
                        "Scenario:"
                    }
                </Text>
                <Text style={styles.text}>
                    {
                        "Thanks to previous campaign. " +
                        "ABC Fruit Company is now one of the most well-known fruit suppliers  " +
                        "Purchase Managers from retail stores can order fruits directly from online store. " +
                        "Most transactions are done by credit sales."
                    }
                </Text>
                <Text style={styles.text}>
                    {
                        "Purchase Managers often query for their credit balance to keep track on the payment needed.  " +
                        "Manager of Sales Department suggested Chris to add the concerned report similar to Bonus Point."
                    }
                </Text>
                <Text style={[styles.text, { paddingBottom: 20 }]}>
                    {
                        "Chris figured out the following report."
                    }
                </Text>
            </View>
        );
    }
}

class Content2 extends Component {
    constructor(props) {
        super(props);

        this.state = {
            heightArr: [40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40],
            widthArr: [100, 150, 430],
            tableHead: ["Name", "Type", "Description"],
            tableData: [
                ["beId", "int(Path)", "Required. Business Entity ID"],
                ["uId", "int(Path)", "Required. User ID. Obsoleted, must input 0 ."],
                ["payRegId", "int(Path)", "Required. Must input 0."],
                ["multiPayId", "int(Path)", "Required. Must input 0."],
                ["AIId", "int(Path)", "Required. Debtor ID. ID of the debtor type's records, if debtor type = cus, this field will represent the ID of customer FM."],
                ["AIType", "string(Header)", "Required. Type of Debtor. Format please refer to request sample, built-in support these types: cus, ven, staff, cnDept, virDept."],
                ["sDate", "date(Header)", "Required. Transaction Date (From)"],
                ["eDate", "date(Header)", "Required. Transaction Date (To)"],
                ["sDDate", "date(Header)", "Required. Due Date (From)"],
                ["eDDate", "date(Header)", "Required. Due Date (To)"],
                ["sStaff", "string(Header)", "Staff Code (From)"],
                ["eStaff", "string(Header)", "Staff Code (To)"],
                ["sTranType", "string(Header)", "Invoice's transaction types. Format please refer to request sample, support types: arIni, arTran and siso."],
                ["loadCrNote", "int(Header)", "Default is 0. If 1, result will include negative AR transactions."],
                ["loadGroupCo", "boolean(Header)", "Default is false. If true, the result will consider group company data of the customer."],
            ],
        }
    }

    render() {
        const state = this.state;

        return (
            <View>
                <Text style={styles.text}>
                    {
                        "To fill in the report, Chris decided to use "
                    }
                    <TouchableOpacity onPress={() => Linking.openURL('http://m18doc.multiable.com/en/ce01/m18erpws.html#get-outstanding-ar-invoices')}>
                        <View>
                            <Text style={styles.hyperlink}>
                                {
                                    "Get Outstanding AR Invoices"
                                }
                            </Text>
                        </View>
                    </TouchableOpacity>
                </Text>
                <Text style={[styles.text, { fontWeight: 'bold' }]}>
                    {
                        "HTTP Request"
                    }
                </Text>
                <Text style={[styles.text, { color: 'red' }]}>
                    {
                        "GET"
                        + "\n"
                        + "http://[server]/jsf/rfws/erp/ac/ar/getOsInvoice/{beId}/{uId}/{AIId}/{recregId}/{multiRecId}"
                    }
                </Text>
                <Text style={[styles.text, { fontWeight: 'bold' }]}>
                    {
                        "Parameters"
                    }
                </Text>
                <Table borderstyle={{ borderWidth: 1 }} style={styles.text}>
                    <Row data={state.tableHead} style={styles.tableCell}
                        widthArr={state.widthArr} textStyle={[styles.tableText, { fontWeight: 'bold' }]} />
                    <Rows data={state.tableData} style={styles.tableCell}
                        widthArr={state.widthArr} textStyle={styles.tableText} heightArr={state.heightArr} />
                </Table>
                <Text style={styles.text}>
                    {
                        "In this case, <AIType> must be “cus”. <AIId> is customer’s entity ID. Yeah, Get ID by Code again. Other parameters are trivial."
                    }
                </Text>
            </View>
        );
    }
}

class Content3 extends Component {
    render() {
        return (
            <View>
                <Text style={[styles.text, { paddingBottom: 20 }]}>
                    {
                        "Response is a typical M18 SqlTable style. It can be confusing to understand. To keep it simple, please only pay attention to <values>."
                    }
                </Text>
                <View style={styles.border}>
                    <Text style={[styles.text, { paddingLeft: 100 }]}>
                        {
                            'values:['
                            + '\n       {'
                            + '\n           "tDate":"2017-09-01 00:00:00",'
                            + '\n           "cpDate":"2017-09-01 00:00:00",'
                        }
                        <Text style={{ color: 'green' }}>
                            {
                                '\n           "code":"KC_ART_20170901_001",'
                            }
                        </Text>
                        {
                            '\n           "virDeptId":3,'
                            + '\n           "st_desc":"KC_ART_20170901_001",'
                            + '\n           "amt":100.0,'
                        }
                        <Text style={{ color: 'orange' }}>
                            {
                                '\n           "balInvDomAmt":110.0,'
                            }
                        </Text>
                        {
                            '\n           "sTranId":396,'
                            + '\n           "ce01Module":"arTran",'
                            + '\n           "sTranCode":"KC_ART_20170901_001",'
                            + '\n           "sTranTypeMess":"arTran",'
                            + '\n           "curId":1,'
                            + '\n           "AIType":"cus",'
                            + '\n           "rate":1.1,'
                            + '\n           "balAmt":100.0,'
                            + '\n           "id":396,'
                            + '\n           "sTranType":"arTran",'
                            + '\n           "curCode":"R",'
                            + '\n           "virDeptCode":"SALES01",'
                            + '\n           "AIId":6,'
                            + '\n           "invDomAmt":110.0,'
                            + '\n           "virDeptDesc":"Sales Team 1"'
                            + '\n       },'
                        }
                    </Text>
                    <Text style={{ paddingLeft: 100, paddingBottom: 20 }}>
                        {
                            '       {'
                            + '\n           "tDate":"2017-09-01 00:00:00",'
                            + '\n           "cpDate":"2017-09-01 00:00:00",'
                        }
                        <Text style={{ color: 'green' }}>
                            {
                                '\n           "code":"KC_ART_20170901_002",'
                            }
                        </Text>
                        {
                            '\n           "virDeptId":3,'
                            + '\n           "st_desc":"KC_ART_20170901_002",'
                            + '\n           "amt":100.0,'
                        }
                        <Text style={{ color: 'orange' }}>
                            {
                                '\n           "balInvDomAmt":110.0,'
                            }
                        </Text>
                        {
                            '\n           "sTranId":397,'
                            + '\n           "ce01Module":"arTran",'
                            + '\n           "sTranCode":"KC_ART_20170901_002",'
                            + '\n           "sTranTypeMess":"arTran",'
                            + '\n           "curId":1,'
                            + '\n           "AIType":"cus",'
                            + '\n           "rate":1.1,'
                            + '\n           "balAmt":100.0,'
                            + '\n           "id":397,'
                            + '\n           "sTranType":"arTran",'
                            + '\n           "curCode":"R",'
                            + '\n           "virDeptCode":"SALES01",'
                            + '\n       },'
                            + '\n]'
                        }
                    </Text>
                </View>
                <Text style={styles.text}>
                    {
                        "There are two outstanding invoices for this customer."
                    }
                </Text>
                <Text style={styles.text}>
                    <Text style={{ color: 'green' }}>
                        {
                            'KC_ART_20170901_001'
                        }
                    </Text>
                    {
                        " with "
                    }
                    <Text style={{ color: 'orange' }}>
                        {
                            '110'
                        }
                    </Text>
                    {
                        " (in domestic currency) outstanding and"
                    }
                </Text>
                <Text style={styles.text}>
                    <Text style={{ color: 'green' }}>
                        {
                            'KC_ART_20170901_002'
                        }
                    </Text>
                    {
                        " with "
                    }
                    <Text style={{ color: 'orange' }}>
                        {
                            '110'
                        }
                    </Text>
                    {
                        " (in domestic currency)"
                    }
                </Text>
                <Text style={[styles.text, { paddingBottom: 20 }]}>
                    {
                        "With all the above knowledge, we are ready to produce a Credit Balance Report."
                    }
                </Text>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    heading: {
        paddingTop: 20,
        fontSize: 30,
        fontWeight: 'bold',
    },
    subheading: {
        paddingTop: 20,
        fontSize: 20,
        fontWeight: 'bold',
    },
    text: {
        paddingTop: 20,
    },
    hyperlink: {
        fontStyle: 'iTalic',
        color: 'blue',
        textDecorationLine: 'underline',
    },
    tableText: {
        margin: 6,
        fontSize: 10
    },
    tableCell: {

    },
    border: {
        borderWidth: 1,
    }
});

export { Content1, Content2, Content3 };



// WEBPACK FOOTER //
// ./src/pages/ap3/Content.js